import { Link } from "react-router-dom"

export type BreadcrumbType = { label: string; url?: string }

const Breadcrumbs = ({
  breadcrumbs,
}: {
  breadcrumbs: Array<BreadcrumbType>
}) => {
  return (
    <ul className="breadcrumb">
      {breadcrumbs.map((breadcrumb, index) =>
        breadcrumb.url ? (
          <li key={index}>
            <Link to={breadcrumb.url} key={index}>
              {breadcrumb.label}
            </Link>
          </li>
        ) : (
          <li key={index}>{breadcrumb.label}</li>
        )
      )}
    </ul>
  )
}

export default Breadcrumbs
